import {useWeb3React } from "@web3-react/core"
import { useState, useEffect } from 'react'
import {VStack, Center, Spinner, Heading, Button, Box, Input, Image } from '@chakra-ui/react';
import { getMeta,getTokenId } from '../lib/nftList'
import nfts from '../lib/nfts'
import SendNFT from './sendNFT'


const Meta = (props) => {
    return <div style={{width: 180, height: 320, display: 'inline-block', boxShadow: '5px 5px 15px 5px rgba(156,156,156,0.3)', borderRadius: 10, padding: 0, margin: 7, textAlign: 'left', cursor: 'pointer'}} onClick={() => props.onClick(props)}>
        <VStack style={{height: '100%', textAlign: 'left'}} >
            <Image src={props.image} alt={props.name}/>
            <div style={{textAlign: 'center', width: '80%', fontSize: 14, fontWeight: 'bold'}}>{props.name}</div>
        </VStack>
    </div>
}

const AdminSendPage = (props) => {
    let [meta, setMeta] = useState([])
    let [sendNftMeta, setSendNftMeta] = useState(null)
    let [tokenIdToSend, setTokenId] = useState(null)

    const sendNFT = (meta) => {
        console.log(meta)
        setSendNftMeta(meta)
        getTokenId(meta.url).then(tokenId=>{
            console.log('tokenID: ' + tokenId)
            setTokenId(tokenId)
        })
    }

    const back = () => {
        setSendNftMeta(null)
        setTokenId(-1)
    }

    
    useEffect(()=>{
        if(!meta || meta.length===0){
            console.log('getting meta')
            getMeta().then(m=>setMeta(m))
        } else {
            console.log('meta: ') 
            console.log(console.log(meta))
        }
    },[meta])
    
    console.log('owner:' + props.isOwner)
    return <>
        {sendNftMeta && <SendNFT meta={sendNftMeta} tokenId={tokenIdToSend} back={back}/>}
        {!sendNftMeta && 
            <VStack>
                
                <VStack style={{ width: 800, textAlign: 'left', marginTop: 30}}>
                    {meta.length>0 && 
                        <div style={{width: 800, textAlign: 'center'}}>
                            {meta.map(m=><Meta key={m.name} {...m} onClick={()=>sendNFT(m)}/>)}
                        </div>
                    }
                </VStack> 
                
            </VStack>
        }
        </>
    
}

export default AdminSendPage